import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showUpdate, remove, getList } from './detectorActions';
import SPButton from '../common/form/spButton';

import ReactTableGT2A from '../common/grid/gridReactTable';
import '../common/grid/grid.css';
import swal from 'sweetalert2';

class DetectorList extends Component {

    componentWillMount() {
        this.props.getList();
    }

    removerDetector(data) {
        swal({
            title: 'Deseja realmente excluir?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: 'primary',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            allowOutsideClick: 'false'
        }).then((result) => {
            if (result.value) {
                this.props.remove(data);
            }
        });  
    }

    render() {

        const detector = this.props.list || [];

        const columns = [
            {
                Header: 'Ações',               
                Cell: row => (
                    <div>
                        <SPButton type='button' className='warning btn-sm' icon='pencil-alt' data-title='Alterar' onClick={() => this.props.showUpdate(row.original)} />
                        <SPButton type='button' className='danger btn-sm' icon='trash-alt' data-title='Excluir' onClick={() => this.removerDetector(row.original)} />
                    </div>
                ),
                className: 'column_icon',
                width: 90,
                resizable: true,
                Filter: () => <div className='rt-th'><span >Filtrar</span></div>
            },
            {
                Header: 'Código',
                accessor: 'id', 
                width: 60,
                className: 'column_grid column_center',
                filterable: true,
                resizable: true,
            },
            {
                Header: 'Descrição',
                accessor: 'descricao',
                className: 'column_grid',
                filterable: true,
                resizable: true,
            }
        ];

        return (

            <ReactTableGT2A
                data={detector}
                columns={columns}
                className='-striped -highlight'
                defaultPageSize={10}                
            />
        )
    }
}
// busca o detectorCad la do reducers.js
const mapStateToProps = state => ({ list: state.detectorCad.list })
const mapDispatchToProps = dispatch => bindActionCreators({ showUpdate, remove, getList }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(DetectorList)
